import { Info } from '@mui/icons-material';
import { Box, Grid, IconButton, Typography } from '@mui/material';
import { LightTooltip } from 'lib/designSystem/WhiteTooltip';
import { formatDateString, getShortString } from 'lib/functions/utils';
import { SummaryRow } from 'pages/Finance/Components/Financing/common/Summary';
import React from 'react';
import { useDispatch } from 'react-redux';
import { showBusinessNetwork } from 'services/redux/businessNetworkSlice';

const productTypeMap = {
  traditional: 'Tradicional',
  earlyPayment: 'Pronto pago',
};

const OperationResume = (props: {
  stakeholderName: string;
  stakeholderIdentifier: string;
  productType?: string;
  requestDate?: string;
}) => {
  const { stakeholderName, stakeholderIdentifier, productType, requestDate } =
    props;
  const dispatch = useDispatch();

  const handleShowBusinessDetails = () => {
    if (stakeholderIdentifier && stakeholderName) {
      dispatch(
        showBusinessNetwork({
          id: stakeholderIdentifier,
          name: stakeholderName,
        }),
      );
    }
  };

  const clientValue =
    stakeholderName && stakeholderIdentifier ? (
      <LightTooltip
        title={
          <Typography variant="body1" style={{ padding: 10 }}>
            {stakeholderName}
          </Typography>
        }
      >
        <Box
          component="span"
          sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
        >
          <IconButton onClick={handleShowBusinessDetails} size="small">
            <Info fontSize="small" />
          </IconButton>
          <Typography variant="body2" component="span">
            {getShortString(stakeholderName, 40)}
          </Typography>
        </Box>
      </LightTooltip>
    ) : (
      (stakeholderName ?? '--')
    );

  return (
    <Grid container spacing={0}>
      <Grid item xs={12}>
        <Box sx={{ pr: 2 }}>
          {stakeholderName != null && (
            <SummaryRow
              label="Cliente"
              value={clientValue}
              labelVariant="body2"
              valueVariant="body2"
              valueMaxLength={30}
            />
          )}
          {stakeholderIdentifier && (
            <SummaryRow
              label="Rut cliente"
              value={stakeholderIdentifier}
              labelVariant="body2"
              valueVariant="body2"
              valueMaxLength={30}
            />
          )}
          {productType && (
            <SummaryRow
              label="Tipo de producto"
              value={productTypeMap[productType as keyof typeof productTypeMap]}
              labelVariant="body2"
              valueVariant="body2"
            />
          )}
          {requestDate && (
            <SummaryRow
              label="Fecha de operación"
              value={formatDateString(requestDate, 'dd-mm-yyyy')}
              labelVariant="body2"
              valueVariant="body2"
              showBorder={false}
            />
          )}
        </Box>
      </Grid>
    </Grid>
  );
};

export default OperationResume;
